import React, { useState } from "react";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon,
    TabsNav,
    Tab
} from "../../components/SharedPageStyles";
import JournalTab from "./tabs/JournalTab";
import StatisticsTab from "./tabs/StatisticsTab";
import PositionCalculatorTab from "./tabs/PositionCalculatorTab";
import IdeasTab from "./tabs/IdeasTab";
import { useJournalData } from "../../context/JournalContext";
import ExportButton from "../../components/ExportButton";



const Metrics = () => {
    const [activeTab, setActiveTab] = useState("Journal");
    const { resetData, rows, isLoading } = useJournalData();

    const renderTabContent = () => {
        switch (activeTab) {
            case "Journal":
                return <JournalTab />;
            case "Statistics":
                return <StatisticsTab />;
            case "Position calculator":
                return <PositionCalculatorTab />;
            case "Ideas":
                return <IdeasTab />;
            default:
                return <JournalTab />;
        }
    };

    return (
        <>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Account Metrics</Chip>
                    <Subtitle><em>Compact view of your key account performance indicators.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={resetData}
                    title="Refresh data"
                    disabled={isLoading}
                    $spinning={isLoading}
                >
                    ⟳
                </BtnIcon>
                <ExportButton data={rows} filename="account_metrics" />
            </ContentActionsRow>

            <TabsNav>
                {["Journal", "Statistics", "Position calculator", "Ideas"].map(tab => (
                    <Tab
                        key={tab}
                        active={activeTab === tab}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </Tab>
                ))}
            </TabsNav>

            {renderTabContent()}
        </>
    );
};

export default Metrics;
